var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",on:{"click":_vm.handleClick}},[_c('div',{ref:"lottie",staticClass:"lottie"}),_c('div',{staticClass:"title-txt"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }